import React from 'react';
import dynamic from 'next/dynamic';

const GoogleMap = dynamic(() => import('../../GoogleMap'), {
	ssr: false,
});

const YandexMap = dynamic(() => import('../../YandexMap'), {
	ssr: false,
});

const MapCDefault = (props) => {
	const mapEngine = 'yandex';
	const Map = mapEngine === 'google' ? GoogleMap : YandexMap;

	return <Map {...props} />;
};

export default MapCDefault;
